import { Skeleton } from '@/components/ui';

function ReviewCardSkeleton() {
  return (
    <div className="flex items-start gap-3 rounded-xl border border-border bg-card p-4">
      <Skeleton
        variant="circular"
        className="h-10 w-10 shrink-0"
      />
      <div className="flex-1 flex flex-col gap-1.5">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-full" />
        <div className="flex gap-2 mt-1">
          <Skeleton className="h-5 w-14 rounded-full" />
          <Skeleton className="h-5 w-20 rounded-full" />
        </div>
      </div>
    </div>
  );
}

/**
 * Content-only skeleton for Inbox (Review tab).
 * Headers (hamburger, title, search, filters) render as real components above this.
 */
export function ReviewTabSkeleton() {
  return (
    <div className="flex flex-col gap-3">
      <ReviewCardSkeleton />
      <ReviewCardSkeleton />
      <ReviewCardSkeleton />
    </div>
  );
}
